import styled from "styled-components";
export const Container = styled.div`
  position: fixed;
  width: 100vw;
  z-index: 999; /* Ensure it's above other elements */
  .active {
    border-bottom: 4px solid var(--white);
    img {
      filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg)
        brightness(103%) contrast(103%);
    }
  }
`;

export const SidebarContainer = styled.div`
  background-color: var(--black);
  width: 350px;
  height: 3.5rem;
  border-radius: 0 0 30px 30px;
  padding: 0 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  top: 0; /* Position at the top */
  right: 0; /* Align to the left */
  z-index: 1000; /* Ensure it's above other elements */
  @media (max-width: 550px) {
    /* Media query for small screens */
    width: 52%; /* Reduce width to 75% */
  }
`;

export const Item = styled.a`
  text-decoration: none;
  color: var(--white);
  height: 100%;
  padding: 0 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: "24px";
  border-bottom: ${(props) =>
    props.isActive ? "4px solid var(--white)" : "none"};
  &:hover {
    border-bottom: 4px solid var(--white);
  }
  @media (max-width: 500px) {
    font-size: 0.8rem; /* Reduce font size on smaller screens */
    padding: 0 4.3%; /* Reduce padding for items */
  }
  @media (max-width: 450px) {
    font-size: 0.8rem; /* Reduce font size on smaller screens */
    padding: 0 3%; /* Reduce padding for items */
  }
  @media (max-width: 400px) {
    font-size: 0.8rem; /* Reduce font size on smaller screens */
    padding: 0 2.5%; /* Reduce padding for items */
  }
  @media (max-width: 330px) {
    font-size: 0.8rem; /* Reduce font size on smaller screens */
    padding: 0 2.5%; /* Reduce padding for items */
  }
`;

export const ImageItem = styled.img`
  width: 100%;
  border-radius: 5px;
`;

export const Spinner = styled.div`
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
  margin-left: 100px;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @media (max-width: 550px) {
    margin-left: 70px;
  }
`;

export const SelectAll = styled.button`
  background-color: var(--black);
  border: none;
  width: ${(props) =>
    props.clicked ? "7rem" : "7rem"}; /* Increase width when clicked */
  height: 2.5rem; /* Keep height the same */
  border-radius: 50px; /* Make it oval */
  margin: 0.5rem 0 0 0.5rem;
  top: 0; /* Position at the top */
  right: ${(props) => (props.clicked ? "360px" : "360px")};
  cursor: pointer;
  z-index: 1500;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  transition: width 0.3s ease; /* Smooth transition for width change */
  color: var(--white); /* Set text color */
  font-weight: bold;
  &::before,
  &::after {
    display: ${(props) =>
      props.clicked ? "none" : "none"}; /* Hide lines when clicked */
    content: "";
    background-color: var(--white);
    height: 2px;
    width: 1rem;
    position: absolute;
    transition: all 0.3s ease;
  }

  &::before {
    top: 1rem; /* Position for the first line */
    transform: rotate(0); /* No rotation */
  }

  &::after {
    top: 1.5rem; /* Position for the second line */
    transform: rotate(0); /* No rotation */
  }
  @media (max-width: 550px) {
    right: ${(props) => (props.clicked ? "55%" : "55%")};
    width: ${(props) =>
      props.clicked ? "6rem" : "6rem"}; /* Increase width when clicked */
  }
  @media (max-width: 450px) {
    right: ${(props) => (props.clicked ? "55%" : "55%")};
    width: ${(props) =>
      props.clicked ? "5.5rem" : "5.5rem"}; /* Increase width when clicked */
  }
  @media (max-width: 400px) {
    right: ${(props) => (props.clicked ? "53%" : "53%")};
    width: ${(props) =>
      props.clicked ? "5.5rem" : "5.5rem"}; /* Increase width when clicked */
  }

  @media (max-width: 360px) {
    right: ${(props) => (props.clicked ? "53%" : "53%")};
    width: ${(props) =>
      props.clicked ? "5rem" : "5rem"}; /* Increase width when clicked */
  }
`;
export const Button = styled.button`
  background-color: var(--black);
  border: none;
  width: ${(props) =>
    props.clicked ? "5rem" : "2.5rem"}; /* Increase width when clicked */
  height: 2.5rem; /* Keep height the same */
  border-radius: 50px; /* Make it oval */
  margin: 0.5rem 0 0 0.5rem;
  top: 0; /* Position at the top */
  right: ${(props) =>
    props.clicked ? "480px" : "20px"}; /* Dynamically set based on clicked */
  cursor: pointer;
  z-index: 1500;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  transition: width 0.3s ease; /* Smooth transition for width change */
  color: var(--white); /* Set text color */
  font-weight: bold;
  &::before,
  &::after {
    display: ${(props) =>
      props.clicked ? "none" : "block"}; /* Hide lines when clicked */
    content: "";
    background-color: var(--white);
    height: 2px;
    width: 1rem;
    position: absolute;
    transition: all 0.3s ease;
  }

  &::before {
    top: 1rem; /* Position for the first line */
    transform: rotate(0); /* No rotation */
  }

  &::after {
    top: 1.5rem; /* Position for the second line */
    transform: rotate(0); /* No rotation */
  }
  @media (max-width: 550px) {
    right: ${(props) =>
      props.clicked ? "77%" : "20px"}; /* Dynamically set based on clicked */
  }
`;

export const Submenu = styled.div`
  position: absolute;
  top: 10px; /* Adjust top positioning for spacing */
  left: 0; /* Align to the left of the container */
  background-color: black;
  width: 250px;
  max-height: 300px; /* Set a fixed maximum height */
  overflow-y: auto; /* Enable vertical scrolling */
  overflow-x: hidden;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 10px;
  border-radius: 10px;
  justify-content: center;
  align-items: center;

  &::-webkit-scrollbar {
    width: 8px; /* Width of the scrollbar */
  }

  &::-webkit-scrollbar-track {
    background: black; /* Background color for the scrollbar track (white) */
    border-radius: 10px; /* Rounded corners for the track */
  }

  &::-webkit-scrollbar-thumb {
    background-color: white; /* Black color for the scrollbar thumb */
    border-radius: 10px; /* Rounded corners */
  }
  @media (max-width: 550px) {
    left: 0; /* Adjust left positioning */
    right: 25px; /* This may not work as intended, consider using width instead */
    width: 100%;
    max-height: 200px;
  }
`;

export const SubmenuLogo = styled.div`
  position: absolute;
  top: 60px;
  left: -50px;
  background-color: black;
  width: 200px;
  max-height: 350px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding: 10px;
  border-radius: 10px;
  @media (max-width: 460px) {
    left: -35%; /* This may not work as intended, consider using width instead */
    width: 95%;
  }
`;

export const SizeOptions = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-color: transparent; /* Make the background transparent */
  border: 2px solid white; /* White border around the rectangle */
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
`;

export const SizeOption = styled.div`
  display: flex;
  align-items: center;
  margin-left: 5px;
`;

export const PositionOptions = styled.div`
  display: grid;
  width: 190px;
  grid-template-columns: repeat(2, 1fr); /* Create a 2x2 grid */
  row-gap: 70px;
  column-gap: 65%;
  background-color: transparent;
  border: 2px solid white;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  @media (max-width: 460px) {
    width: 100%;
    column-gap: 65%;
  }
`;

export const PositionOption = styled.div`
  display: flex;
  align-items: center;
`;

export const PositionLabel = styled.label`
  margin-left: 5px;
  font-size: 14px;
`;

export const SizeLabel = styled.label`
  margin-left: 5px;
  font-size: ${(props) =>
    props.size === "small"
      ? "12px"
      : props.size === "medium"
      ? "14px"
      : "16px"};
`;

export const RadioButton = styled.input`
  width: ${(props) =>
    props.value === "small"
      ? "12px"
      : props.value === "medium"
      ? "16px"
      : "20px"};
  height: ${(props) =>
    props.value === "small"
      ? "12px"
      : props.value === "medium"
      ? "16px"
      : "20px"};
`;
export const Dropdown = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  @media (max-width: 500px) {
    width: 97%;
  }
  @media (max-width: 460px) {
    width: 150%;
  }
  @media (min-width: 348px) and (max-width: 400px) {
    width: 140%;
  }
  @media (max-width: 395px) {
    width: 130%;
  }
  @media (max-width: 369px) {
    width: 120%;
  }
`;

export const LogoPositionLabel = styled.label`
  color: var(--white);
`;

export const Logout = styled.button`
  border: none;
  width: 2rem;
  height: 2rem;
  background-color: transparent;
  svg {
    width: 100%;
    height: auto;
    filter: invert(15%) sepia(70%) saturate(6573%) hue-rotate(2deg)
      brightness(100%) contrast(126%);
    transition: all 0.3s ease;
    &:hover {
      border: none;
      padding: 0;
      opacity: 0.5;
    }
  }
`;

export const ApplyButton = styled.button`
  background-color: white;
  color: black;
  padding: 10px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
  &:hover {
    background-color: lightgray;
  }

  @media (max-width: 550px) {
    max-height: 50px;
    margin-top: 5px;
  }
`;

export const AddDecorationButton = styled.button`
  position: absolute;
  bottom: 0.5px; /* Position button at the bottom of the container */
  left: 0; /* Align to the left of the container */
  width:250px;
  padding: 10px 15px; // Button padding
   font-size: 16px;
  background-color: ${({ disabled }) =>
    disabled ? "lightgray" : "white"}; // Change background if disabled
  color: ${({ disabled }) => (disabled ? "darkgray" : "black")}; /

   border: none;
  border-radius: 5px; // Rounded corners
  transition: background-color 0.3s; // Smooth transition for background color
   cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
 &:hover {
    background-color: lightgray;
  }
      @media (max-width: 550px) {
     left: 0;
    width:100%
    
  }
`;

export const Containerframes = styled.div`
  height: 360px; /* Adjust height to fit both components */
  width: 250px;
  position: absolute;
  top: 70px;
  background-color: black;
  border-radius: 10px; /* Rounded corners for the container */
  overflow: hidden; /* Prevent overflow */
  @media (max-width: 550px) {
    left: 0; /* Adjust left positioning */
    right: 25px; /* This may not work as intended, consider using width instead */
    width: 100%;
    max-height: 250px;
  }
`;

export const CenterIcon = styled.div`
  position: absolute;
  top: 65%;
  left: 53%;
  transform: translate(-50%, -50%);
  color: white;
`;
